import React from "react";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./SpaceSizeEdit.css";

const { t } = new Translate();

const Area = ({ area, onChange }) => (
  <div className={styles.root}>
    <input
      autoComplete="off"
      onChange={(e) => onChange({ ...area, value: e.target.value })}
      type="text"
      value={area.value}
    />
    <div className={styles.small}>{t(`units.${area.unit}`, 2)}</div>
  </div>
);

Area.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default Area;
